import { Component, Input, ViewChild, ChangeDetectorRef } from '@angular/core';

import { Message } from '../../models/models';
import { Paginator } from '../../models/interfaces';
import { InfiniteScroll, ToastController } from 'ionic-angular';


@Component({
	selector: 'message-list',
	templateUrl: 'message-list.html'
})
export class MessageListComponent {
	@ViewChild('scroller') private infiniteScroll: InfiniteScroll;

	public isFirstLoading: boolean = true;
	public isLoading: boolean = true;

	private _paginator: Paginator<Message>;

	@Input() public messages: Message[] = null;


	/**
	Se false il click non produce apertura messaggio
	*/
	@Input() public isClickable: boolean = true;

	@Input() public isDatetimeVisible: boolean = true;

	@Input() public isDeviceVisible: boolean = true;

	/**
	Se false il menù interattivo non è visibile
	*/
	@Input() public isMenuVisible: boolean = true;
	/*
	Se false non può aprire il messaggio anche se ha i permessi
	*/
	@Input() public isShowable: boolean = true;
	/**
	Per visualizzare il mittente
	*/
	@Input() public isSenderVisible: boolean = true;
	/**
	Se false non visualizza la riga con i dati del condominio
	*/
	@Input() public isReceiverVisible: boolean = false;

	@Input() public pageSize: number = 10;
	@Input() public set paginator(paginator: Paginator<Message>) {
		this._paginator = paginator;

		if (paginator) {
			this.load(null, true);
		}
	}

	/**
	Dimensione dei tasselli dei messaggi
	*/
	@Input() public size: number = 3;

	constructor(
		private changeDetector: ChangeDetectorRef,
		private toastCtrl: ToastController
	) {
	}

	/**
	Carica messaggi, paginati o da capo
	*/
	public load(
		infiniteScroll: InfiniteScroll,
		forceReload = false
	): Promise<void> {
		if (!this._paginator) {
			console.debug('Paginatore non pronto, posticipo il caricamento')
			return;
		}

		let self = this;

		let lastMessage: Message = null;

		if (this.isFirstLoading || forceReload) {
			this.messages = [];
		} else if (this.messages.length > 0) {
			lastMessage = this.messages[this.messages.length - 1];
		}

		return new Promise((resolve, reject) => {
			this._paginator.next(lastMessage, self.pageSize).then((messages: Message[]) => {
				console.debug('Caricati nuovi messaggi: ', messages)
				for (let message of messages) {
					self.messages.push(message);
				}



				/*
				fine caricamento gestito nel template con waitFor
				infiniteScroll.complete();
				*/

				if (self.pageSize > messages.length) {//fine del caricamento
					console.debug('Fine del caricamento messaggi')
					//infiniteScroll.target.disabled = true
					if (infiniteScroll) {
						infiniteScroll.enable(false);
					}
				}

				self.isLoading = false;
				self.isFirstLoading = false;

				self.changeDetector.detectChanges()

				resolve()
			}).catch(e => {
				console.error('Errore caricando altri messaggi: ', e)
				self.isLoading = false;

				/*
				fine caricamento gestito nel template con waitFor ma qui siamo in reject
				*/
				if (infiniteScroll) {
					infiniteScroll.complete();
				}

				let toast = self.toastCtrl.create({
					message: 'Errore recuperando i messaggi',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				});
				toast.present();

				self.changeDetector.detectChanges()

				reject()
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/message-list/message-list.ts